import React from "react";
import { Assets } from "../../assets";
import { useAnimationTutorialInit } from "../../hooks/animation/useAnimationTutorialInit";

export const NotificationInit = () => {
	const { closeTutorial, container } = useAnimationTutorialInit();
	return (
		<div
			ref={container}
			className="absolute z-20 hidden opacity-0  -top-16 left-8 sm:left-32  w-[300px] h-[60px] lg:-left-[300px] lg:top-[80%] lg:h-[80px] rounded-2xl overflow-hidden "
		>
			<div className="relative bg-[#C5C5C5] h-full text-[12px] lg:text-[14px] pl-3 pr-1 pt-1.5 border-b-4 border-secondary">
				<div className="absolute right-2 top-0 cursor-pointer " onClick={closeTutorial}>
					<img className="h-full w-full" src={Assets.icon.close_sm} alt="close" />
				</div>
				<div>
					<span>
						<b>UAM</b> TIPS:
					</span>
				</div>
				<div>
					<p>
						<b>Pulsa y desliza para visualizar la foto 360</b>
					</p>
				</div>
			</div>
		</div>
	);
};
